export default __webpack_public_path__ + "static/media/color.4333fbe2.svg";